import { defineComponent as o, ref as f, inject as m, watchEffect as d, h } from "vue";
import { colorPickerInjectionKey as c } from "./ghl-ui.es917.js";
import p from "./ghl-ui.es182.js";
function U(e) {
  return /^\d{1,3}\.?\d*$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e), 255)) : !1;
}
function I(e) {
  return /^\d{1,3}\.?\d*$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e), 360)) : !1;
}
function g(e) {
  return /^\d{1,3}\.?\d*$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e), 100)) : !1;
}
function V(e) {
  const a = e.trim();
  return /^#[0-9a-fA-F]+$/.test(a) ? [4, 5, 7, 9].includes(a.length) : !1;
}
function b(e) {
  return /^\d{1,3}\.?\d*%$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e) / 100, 100)) : !1;
}
const M = {
  paddingSmall: "0 4px"
}, k = o({
  name: "ColorInputUnit",
  props: {
    label: {
      type: String,
      required: !0
    },
    value: {
      type: [Number, String],
      default: null
    },
    showAlpha: Boolean,
    onUpdateValue: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const a = f(""), {
      themeRef: l
    } = m(c, null);
    d(() => {
      a.value = r();
    });
    function r() {
      const {
        value: n
      } = e;
      if (n === null)
        return "";
      const {
        label: t
      } = e;
      return t === "HEX" ? n : t === "A" ? `${Math.floor(n * 100)}%` : String(Math.floor(n));
    }
    function u(n) {
      a.value = n;
    }
    function s(n) {
      let t, i;
      switch (e.label) {
        case "HEX":
          i = V(n), i && e.onUpdateValue(n), a.value = r();
          break;
        case "H":
          t = I(n), t === !1 ? a.value = r() : e.onUpdateValue(t);
          break;
        case "S":
        case "L":
        case "V":
          t = g(n), t === !1 ? a.value = r() : e.onUpdateValue(t);
          break;
        case "A":
          t = b(n), t === !1 ? a.value = r() : e.onUpdateValue(t);
          break;
        case "R":
        case "G":
        case "B":
          t = U(n), t === !1 ? a.value = r() : e.onUpdateValue(t);
          break;
      }
    }
    return {
      mergedTheme: l,
      inputValue: a,
      handleInputChange: s,
      handleInputUpdateValue: u
    };
  },
  render() {
    const {
      mergedTheme: e
    } = this;
    return h(p, {
      size: "small",
      placeholder: this.label,
      theme: e.peers.Input,
      themeOverrides: e.peerOverrides.Input,
      builtinThemeOverrides: M,
      value: this.inputValue,
      onUpdateValue: this.handleInputUpdateValue,
      onChange: this.handleInputChange,
      // add more space for xxx% input
      style: this.label === "A" ? "flex-grow: 1.25;" : ""
    });
  }
});
export {
  k as default
};
